import { Mail, MailCheck } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";

import type { ClaimWithRelations } from "../../api/use-claim";
import { ConversationSelectionModal } from "../emails/conversation-selection-modal";

/** Port of states-cta/EmailConversationCTA.vue — génération de la conversation email. */
export function EmailConversationCTA({ claim }: { claim: ClaimWithRelations }) {
  const [showModal, setShowModal] = useState(false);

  const hasEmailConversation = claim.claimDocuments?.some(
    (doc) => doc.documentType.type === "EMAIL_CONVERSATION",
  );

  return (
    <>
      <div className="border-b bg-slate-50">
        <div className="mx-auto max-w-xl py-5 text-left">
          <div className="rounded-md border bg-white p-6 shadow">
            <div className="mb-4 flex items-center gap-3">
              <div className={`rounded-full p-2 ${hasEmailConversation ? "bg-green-100" : "bg-blue-100"}`}>
                {hasEmailConversation ? (
                  <MailCheck className="h-6 w-6 text-green-600" />
                ) : (
                  <Mail className="h-6 w-6 text-blue-600" />
                )}
              </div>
              <div>
                <h2 className="text-base leading-6 font-semibold text-gray-900">Conversation email</h2>
                <p className="text-sm text-gray-500">
                  {hasEmailConversation
                    ? "La conversation email a été générée. Vous pouvez la régénérer en sélectionnant les emails à inclure."
                    : "Sélectionnez les emails à inclure dans le dossier de plaidoirie."}
                </p>
              </div>
            </div>

            <div className="text-center">
              <Button onClick={() => setShowModal(true)}>
                <Mail />
                {hasEmailConversation ? "Modifier la sélection" : "Sélectionner les emails à inclure"}
              </Button>
            </div>
          </div>
        </div>
      </div>

      <ConversationSelectionModal claimId={claim.id} open={showModal} onClose={() => setShowModal(false)} />
    </>
  );
}
